import {
  CloseButton,
  CrudMode,
  DELETE_WARNING,
  DropDownMenu,
  UpdateButton,
  MenuItemType,
  newToast,
  Typography,
  ValidationErrors,
  Stack,
  ListContextValue,
  ListContext,
} from "@compass/core";
import { DataModelInformation, SubmitButton } from "components";
import { ProviderEmployment, DataModelEnum, Permission, PermissionAction } from "generated/openApi";
import { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setAppToast } from "redux/reducers/appSlice";
import { isAuthorized } from "services";
import ApiService from "services/apiService";

export const ProviderEmploymentPageHeader = (props: {
  rootPermission: Permission;
  handle: string;
  crudMode: CrudMode;
  reroute: (id: number, crudMode: CrudMode) => void;
  fetch: (id: number) => void;
  employment: ProviderEmployment;
  setValidationErrors: (errors: ValidationErrors) => void;
  unsavedChanges: boolean;
  parentListContext?: ListContextValue;

}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const listContext = useContext<ListContextValue>(ListContext);
  const id = props.employment.id;

  const save = (employment: ProviderEmployment) => {
    props.setValidationErrors({});

    if (id > 0) {
      ApiService.providerEmployments
        .saveUpdate(employment)
        .then(() => {
          props.reroute(id, "view");
          props.fetch(id);
          dispatch(setAppToast(newToast("success")));
          props.parentListContext?.loadList?.();
          navigate("../");
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.response);
        });
    } else {
      ApiService.providerEmployments
        .saveCreate(employment)
        .then((response) => {
          const id = response;
          props.reroute(id, "view");
          props.parentListContext?.loadList?.();
          dispatch(setAppToast(newToast("success")));
          navigate("../");
        })
        .catch((ex) => {
          dispatch(setAppToast(newToast("error")));
          props.setValidationErrors(ex.response);
        });
    }
  };

  const postDelete = (id: number) => {
    if (window.confirm(DELETE_WARNING)) {
      ApiService.providerEmployments.delete(id).then(() => {
        navigate("../");
        listContext.loadList?.();
        dispatch(setAppToast(newToast("success")));
      });
    }
  };

  const menuItems: MenuItemType[] = [];
  if (id > 0) {
    if (isAuthorized(props.rootPermission, PermissionAction.Delete))
      menuItems.push({
        label: <Typography color="error">Delete</Typography>,
        action: () => postDelete(id),
      });
  }

  return (
    <Stack direction="row" justifyContent="space-between">
      <Stack direction="row" alignItems="center">
        <Typography variant="inherit">
          {id === 0 ? "New" : ""} {props.handle}
        </Typography>
        {menuItems.length > 0 && <DropDownMenu menuItems={menuItems} />}
      </Stack>

      <Stack direction="row" alignItems="center" spacing="sm">
        {id > 0 && <DataModelInformation dataModelType={DataModelEnum.ProviderEmployment} dataModelId={id} />}

        <CloseButton confirm={props.unsavedChanges} />

        {props.crudMode === "view" && isAuthorized(props.rootPermission, PermissionAction.Update) && (
          <UpdateButton onClick={() => props.reroute(id, "edit")} />
        )}

        {props.crudMode === "edit" && (
          <SubmitButton onClick={() => save(props.employment!)} disabled={!props.unsavedChanges} />
        )}
      </Stack>
    </Stack>
  );
};
